export const classes = {
  item: 'w-auto mx-3 py-3 px-2 rounded-lg hover:bg-grey-2 dark:hover:bg-white/[0.06] bg-white dark:bg-transparent',
  text: 'select-none text-grey-8 dark:text-mauve-1 my-0',
};
